import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { WeeklyRating } from '@/domain/entities/dashboard/weeklyRating'
import { WeeklyRatingModuleName } from '@/store/modules/modules'

export class WeeklyRatingViewModel {
  private store = useStore()

  userWeeklyRatingList: ComputedRef<WeeklyRating[][]> = computed(
    () => this.store.getters[`${WeeklyRatingModuleName}/userWeeklyRatingList`]
  )
  chartData: ComputedRef<{ labelChartData: number[]; weeklyRatingChartData: number[][]; maxRating: number }> = computed(
    () => this.store.getters[`${WeeklyRatingModuleName}/chartData`]
  )
  chartSeries: ComputedRef<any[]> = computed(() => this.store.getters[`${WeeklyRatingModuleName}/chartSeries`])
  chartOptions: ComputedRef<any> = computed(() => this.store.getters[`${WeeklyRatingModuleName}/chartOptions`])
  hasData: ComputedRef<boolean> = computed(() => this.store.getters[`${WeeklyRatingModuleName}/hasData`])
  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${WeeklyRatingModuleName}/isLoading`])
  error: ComputedRef<string | null> = computed(() => this.store.getters[`${WeeklyRatingModuleName}/error`])

  async addUserWeeklyRating(userId: string): Promise<void> {
    await this.store.dispatch(`${WeeklyRatingModuleName}/addUserWeeklyRating`, { userId: userId })
  }

  removeUserWeeklyRating(): void {
    this.store.commit(`${WeeklyRatingModuleName}/removeUserWeeklyRating`)
  }

  removeTargetUsers(): void {
    this.store.commit(`${WeeklyRatingModuleName}/removeTargetUsers`)
  }

  setChartData(chartData: { labelChartData: number[]; weeklyRatingChartData: number[][]; maxRating: number }): void {
    this.store.commit(`${WeeklyRatingModuleName}/setChartData`, chartData)
  }

  setChartSeries(chartSeries: any[]): void {
    this.store.commit(`${WeeklyRatingModuleName}/setChartSeries`, chartSeries)
  }

  setChartOptions(chartOptions: any): void {
    this.store.commit(`${WeeklyRatingModuleName}/setChartOptions`, chartOptions)
  }

  setHasData(hasData: boolean): void {
    this.store.commit(`${WeeklyRatingModuleName}/setHasData`, hasData)
  }
}
